import { render, staticRenderFns } from "./createDocumentClassification.vue?vue&type=template&id=ea66ac4c&scoped=true"
import script from "./createDocumentClassification.vue?vue&type=script&lang=js"
export * from "./createDocumentClassification.vue?vue&type=script&lang=js"
import style0 from "./createDocumentClassification.vue?vue&type=style&index=0&id=ea66ac4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea66ac4c",
  null
  
)

export default component.exports